// extracted by mini-css-extract-plugin
module.exports =  {"button":"ece2611c53--button--fdUtZ"};